import { Box, Button, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AddButton from "../../../common/components/functional/addButton/AddButton";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import UnionReportModal from "./UnionReportModal";
import { UnionListItem } from "./unionsApi";
import {
  gridUnionNameStyles,
  gridUnionNumberStyles,
  headerStyles,
} from "./unionsStyles";

interface Props {
  unions: UnionListItem[];
  setSelectedUnionId: (id: string) => void;
}

const UnionsList = ({ unions, setSelectedUnionId }: Props) => {
  const [reportModal, setReportModal] = useState<boolean>(false);

  const { t } = useTranslation("settings");

  return (
    <>
      <Box
        sx={{
          fontFamily: "Quicksand",
          fontSize: "32px",
          fontWeight: 600,
          padding: "10px 0px 20px 0px",
          width: "60%",
        }}
      >
        {t("unions")}
      </Box>
      <Grid container spacing={2} style={{ paddingLeft: "10px", width: "60%" }}>
        <Grid item xs={10} style={headerStyles}>
          <Typography variant="subtitle1">{t("unionName")}</Typography>
        </Grid>
        <Grid item xs={2} style={headerStyles}>
          <Typography variant="subtitle1">{t("unionNumber")}</Typography>
        </Grid>
        {unions.map((union, index) => (
          <Grid container key={index} style={{ flexWrap: "nowrap" }}>
            <Grid item xs={10} style={gridUnionNameStyles}>
              <Typography
                onClick={() => union?.id && setSelectedUnionId(union.id)}
              >
                {union.name}
              </Typography>
            </Grid>
            <Grid item xs={2} style={gridUnionNumberStyles}>
              <Typography>{union.tradeUnionNumber}</Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>

      <Box
        sx={{
          marginLeft: "10px",
        }}
      >
        <AddButton
          variant="outlined"
          sx={{
            margin: "16px 0px 32px 0px",
            alignSelf: "flex-start",
            background: "#f7f7f9",
            height: "36px",
            borderRadius: "18px",
            borderColor: "rgba(74, 29, 156, 0.5)",
          }}
          label={t("addNewUnion")}
          onClick={() => setSelectedUnionId("new")}
        />
        <Button
          sx={{
            margin: "16px 0px 32px 10px",
            height: "36px",
            textTransform: "none",
            borderRadius: "18px",
            fontWeight: "700",
            background: "#f7f7f9",
            borderColor: "rgba(74, 29, 156, 0.5)",
            color: "magenta",
          }}
          variant={"outlined"}
          onClick={() => setReportModal(true)}
        >
          {t("createRaport")}
        </Button>
      </Box>
      <DialogComponent
        open={reportModal}
        onClose={() => setReportModal(false)}
        autoWidth
        backgroundColor={"#FFFFFF"}
        DialogContentProps={{
          sx: { padding: "0px" },
        }}
      >
        <UnionReportModal setReportModal={setReportModal} />
      </DialogComponent>
    </>
  );
};

export default UnionsList;
